export const SHARE_ON_SOCIAL = 'social/SHARE_ON_SOCIAL'

// shareOnSocial :: String -> Action
export const shareOnSocial = socialName => ({
    type: SHARE_ON_SOCIAL,
    socialName,
})
